module.exports = __webpack_public_path__ + "img/mealreminder-user-2.927c4db1.png";